/* global bocAmchart4, am4core, am4charts, chartLanguage */
/**
 * Get colors for the map from the shortcode or define defaults
 * @param {object} chart object
 * @param {object} fill am4core color passed from amcharts
 * @param {object} target from template adapter, source of data item
 * @returns {object} am4core color
 */
bocAmchart4.calculateHeatmapColors = function (chart, fill, target) {
    var markerCount = 2;
    var index;
    var legendBuckets = bocAmchart4.vars[chart.bocSettings.id].legendBuckets;

    // Override markerCount with user-defined shortcode values
    if (chart.bocSettings.args.hasOwnProperty('markercount')) {
        markerCount = parseFloat(chart.bocSettings.args.markercount);
    }

    // Set min and max values either from dataset defaults or user-defined values
    var minValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].minValue);
    var maxValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].maxValue);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Using these min/max:",
            "Min value: " + minValue,
            "Max value: " + maxValue,
            "Marker count:" + markerCount
        );
    }

    var mainColors = bocAmchart4.vars[chart.bocSettings.id].mainColors;
    var rect;
    bocAmchart4.vars[chart.bocSettings.id].locale = (chartLanguage === "fr") ? 'fr-CA' : 'en-CA';

    // This condition is to check if legend has already been set up, otherwise it skips directly to assigning a fill colour to the datapoint
    if (bocAmchart4.vars[chart.bocSettings.id].hasOwnProperty("maxLabel")) {
        bocAmchart4.vars[chart.bocSettings.id].maxLabel.text = bocAmchart4.locale(chart, maxValue);
    } else {
        // Create heat legend container and size
        let heatLegend = chart.bottomAxesContainer.createChild(am4core.Container);
        heatLegend.width = am4core.percent(100);
        heatLegend.height = 20;
        heatLegend.align = "right";
        heatLegend.valign = "top";
        heatLegend.layout = "horizontal";

        // Create a container for the legend labels
        let legendLabelContainer = chart.bottomAxesContainer.createChild(am4core.Container);
        legendLabelContainer.layout = "horizontal";
        legendLabelContainer.valign = "top";
        legendLabelContainer.layout = "absolute";
        legendLabelContainer.width = am4core.percent(100);

        // Create label container for minimum bucket
        let legendLabelMin = legendLabelContainer.createChild(am4core.Label);
        legendLabelMin.fontSize = "0.875em";

        // Array to hold the rectangles for each bucket of values in the legend
        rect = [];
        bocAmchart4.vars[chart.bocSettings.id].allColors = [];

        for (index = 0; index < markerCount; index++) {
            // Create new rectangle for each bucket (based on markerCount)
            rect[index] = heatLegend.createChild(am4core.Rectangle);
            rect[index].width = am4core.percent(100);
            rect[index].height = 15;
            rect[index].strokeWidth = 0;
            if (index === 0) {
                // Assign first colour in mainColours to the first bucket in the legend
                fill = mainColors[index];
            } else if (index === markerCount - 1) {
                // Assign last colour in mainColours to the last bucket in the legend
                fill = mainColors[mainColors.length - 1];
            } else {
                // Find the next gradient colour
                let relValueLegend = (index / (markerCount - 1));
                let arrayRangeLegend = relValueLegend * (mainColors.length - 1);
                let baseIdxLegend = Math.floor(arrayRangeLegend);
                let gradientRangeLegend = arrayRangeLegend - baseIdxLegend;

                fill = am4core.colors.interpolate(
                    mainColors[baseIdxLegend].rgb,
                    mainColors[baseIdxLegend + 1].rgb,
                    gradientRangeLegend
                );
            }

            // Add colour to allColors variable and to rectangle
            bocAmchart4.vars[chart.bocSettings.id].allColors[index] = {
                'color': fill
            };
            rect[index].fill = fill;
        }

        // Assign low and high values to each colour
        let allColors = bocAmchart4.vars[chart.bocSettings.id].allColors;
        allColors[0].low = legendBuckets[0];
        allColors[0].high = legendBuckets[1];
        for (index = 1; index < legendBuckets.length - 1; index++) {
            allColors[index].low = legendBuckets[index];
            allColors[index].high = legendBuckets[index + 1];
        }
        allColors[index - 1].high = legendBuckets[index];

        // Sets up tooltips/labels based on whether min overflow bucket exists
        if (allColors[0].low === false) {
            // Overflow bucket exists so align the label with the first divider
            legendLabelMin.text = bocAmchart4.locale(chart, allColors[0].high);
            legendLabelMin.opacity = 0;

            chart.events.on("sizechanged", function () {
                // Force label to validate and calculate its dimensions
                legendLabelMin.validate();
                let firstRect = rect[0];
                let secondRect = rect[1];

                // Calculate the midpoint of the divider between first and second rectangle
                let firstDividerMidpoint = (firstRect.pixelX + firstRect.pixelWidth + secondRect.pixelX) / 2;

                // Position the min label
                legendLabelMin.x = firstDividerMidpoint - legendLabelMin.measuredWidth / 2;
                legendLabelMin.opacity = 1;
            });
        } else {
            // No overflow so place label at the start of the legend
            legendLabelMin.align = "left";
            legendLabelMin.valign = "top";
            legendLabelMin.text = bocAmchart4.locale(chart, allColors[0].low);
        }
        bocAmchart4.vars[chart.bocSettings.id].minLabel = legendLabelMin;

        // Create label container for maximum bucket
        let legendLabelMax = legendLabelContainer.createChild(am4core.Label);
        legendLabelMax.fontSize = "0.875em";

        // Sets up tooltips/labels based on whether max overflow bucket exists
        if (allColors[allColors.length - 1].high === false) {
            // Overflow bucket exists so align the label with the last divider
            legendLabelMax.text = bocAmchart4.locale(chart, allColors[allColors.length - 1].low);
            legendLabelMax.opacity = 0;

            chart.events.on("sizechanged", function () {
                // We need to set the text again, otherwise it defaults to another value
                legendLabelMax.text = bocAmchart4.locale(chart, allColors[allColors.length - 1].low);

                // Force label to validate and calculate its dimension
                legendLabelMax.validate();

                let lastRect = rect[markerCount - 1];
                let secondLastRect = rect[markerCount - 2];

                // Calculate the midpoint of the divider between secondLast and last rectangle
                let lastDividerMidpoint = (secondLastRect.pixelX + secondLastRect.pixelWidth
                    + lastRect.pixelX) / 2;

                // Position the max label
                legendLabelMax.x = lastDividerMidpoint - legendLabelMax.measuredWidth / 2;
                legendLabelMax.opacity = 1;
            });
        } else {
            // No overflow so place label at the end of the legend
            legendLabelMax.align = "right";
            legendLabelMax.text = bocAmchart4.locale(chart, allColors[allColors.length - 1].high);
        }
        bocAmchart4.vars[chart.bocSettings.id].maxLabel = legendLabelMax;

        // Set tooltip text for all rectangles
        // Tooltip for the first bucket
        if (allColors[0].low === false) {
            rect[0].tooltipText = "< " + legendLabelMin.text;
        } else {
            rect[0].tooltipText = bocAmchart4.locale(chart, allColors[0].low) + " ≥ \n< "
                + bocAmchart4.locale(chart, allColors[0].high);
        }

        // Tooltips for the middle buckets
        for (let index = 1; index < (markerCount - 1); index++) {
            rect[index].tooltipText = bocAmchart4.locale(chart, allColors[index].low) + " ≥ \n< "
                + bocAmchart4.locale(chart, allColors[index].high);
        }

        // Mid-labels are to be displayed
        if (chart.bocSettings.args.hasOwnProperty('heatmapdisplaymidlabels') &&
            chart.bocSettings.args.heatmapdisplaymidlabels !== 'false') {
            // Array to hold midColorValue labels
            let midColorValueLabels = [];
            chart.events.on("sizechanged", function () {
                let isMobileSize = window.innerWidth < 768;

                // Clear existing midColorValue labels while keeping min and max
                midColorValueLabels.forEach(function (label) {
                    label.label.dispose();
                });

                // Reset the array for new labels
                midColorValueLabels = [];

                // Display midColorValue labels when the screen size is big enough
                if (!isMobileSize) {
                    let midColorValuesForTickLabels = bocAmchart4.vars[chart.bocSettings.id].midColorValuesForTickLabels;
                    // Loop through midColorValuesForTickLabels and check if it falls within the rect range
                    midColorValuesForTickLabels.forEach(function (midColorValue) {
                        for (let index = 0; index < markerCount; index++) {
                            // This condition is to check if the midColorValue falls within a bucket
                            if ((midColorValue >= allColors[index].low && midColorValue < allColors[index].high
                                // and to display it only if it matches the lower end
                                && midColorValue === allColors[index].low)) {

                                let midColorValueLabel = legendLabelContainer.createChild(am4core.Label);
                                midColorValueLabel.opacity = 0;
                                midColorValueLabel.text = bocAmchart4.locale(chart, midColorValue);
                                midColorValueLabel.fontSize = "0.875em";
                                midColorValueLabel.horizontalCenter = 'middle';
                                midColorValueLabels.push({
                                    index: index,
                                    label: midColorValueLabel
                                });
                            }
                        }
                        midColorValueLabels.forEach(function (label) {
                            // Align the label to the middle of the divider
                            let prevRect = rect[label.index - 1];
                            let currentRect = rect[label.index];
                            label.label.x = (prevRect.pixelX + currentRect.pixelWidth + currentRect.pixelX) / 2;
                            label.label.opacity = 1;
                        });
                    });
                }
            });
        }

        // Tooltip for the last bucket
        if (allColors[allColors.length - 1].high === false) {
            rect[markerCount - 1].tooltipText = "≥ " + legendLabelMax.text;
        } else {
            rect[markerCount - 1].tooltipText = bocAmchart4.locale(chart, allColors[allColors.length - 1].low) +
                " ≥ \n≤ " + bocAmchart4.locale(chart, allColors[allColors.length - 1].high);
        }
    }

    if (!isNaN(target.dataItem.value)) {
        var value = target.dataItem.value;
        var allColorsMap = bocAmchart4.vars[chart.bocSettings.id].allColors;
        var minOverflowBucket = allColorsMap[0].low;
        var maxOverflowBucket = allColorsMap[allColorsMap.length - 1].high;
        // Get fill color based on value
        fill = bocAmchart4.getFillColor(value, allColorsMap, markerCount, minOverflowBucket, maxOverflowBucket);
    }
    return fill;
};

/**
 * Set up the default Amcharts4 heatmap legend with either default/user-defined colours
 * @param {object} chart object
 * @param {object} series target series
 * @param {object} columnTemplate series column template
 * @returns {void}
 */
bocAmchart4.defaultHeatmapLegend = function (chart, series, columnTemplate) {
    var mainColors = bocAmchart4.vars[chart.bocSettings.id].mainColors;

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Using these colors:",
            mainColors
        );
    }

    // Set up heat rules for series with either default or user-defined colours
    series.heatRules.push({
        target: columnTemplate,
        property: "fill",
        min: mainColors[0],
        max: mainColors[mainColors.length - 1]
    });

    // Create Amcharts heat legend
    var heatLegend = chart.bottomAxesContainer.createChild(am4charts.HeatLegend);
    heatLegend.width = am4core.percent(100);
    heatLegend.series = series;
    heatLegend.valueAxis.renderer.labels.template.fontSize = "0.563em";
    heatLegend.valueAxis.renderer.minGridDistance = 30;

    // Heat legend behaviour
    series.columns.template.events.on("over", (event) => {
        handleHover(event.target);
    });

    series.columns.template.events.on("hit", (event) => {
        handleHover(event.target);
    });

    /**
     * Show legend tooltip when hovering over a datapoint
     * @param {object} column object
     * @returns {void}
     */
    function handleHover(column) {
        if (!isNaN(column.dataItem.value)) {
            heatLegend.valueAxis.showTooltipAt(column.dataItem.value);
        } else {
            heatLegend.valueAxis.hideTooltip();
        }
    }

    series.columns.template.events.on("out", () => {
        heatLegend.valueAxis.hideTooltip();
    });
};
